
import React from 'react';

import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CookieBanner from './components/CookieBanner';


import { LocalizationProvider }        from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns }              from '@mui/x-date-pickers/AdapterDateFns';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>

    <LocalizationProvider dateAdapter={AdapterDateFns}>
            <CookieBanner />

      <App />
    </LocalizationProvider>
  </React.StrictMode>
);

reportWebVitals();
